import { useMutation } from '@occc-app/dataAccessLayer/utils';
import {
  useUpdateScanDataSftpCredentialsMutation as useApolloUpdateScanDataSftpCredentialsMutation,
  UpdateScanDataSftpCredentialsMutationOptions,
} from '@occc/graphql';

export const useUpdateScanDataSftpCredentials = (
  baseOptions: UpdateScanDataSftpCredentialsMutationOptions,
) => useMutation(useApolloUpdateScanDataSftpCredentialsMutation, baseOptions);
